
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCards() {
        const url = `${API_URL}/analytics/cards`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getYear() {
        const url = `${API_URL}/analytics/year`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getUndelivered(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = `${API_URL}/analytics/undelivered${query ? `?${query}` : ''}`;
        return axios.get(url, { headers: authHeader() });
    },
    getUnvalidate(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = `${API_URL}/analytics/unvalidated${query ? `?${query}` : ''}`;
        return axios.get(url, { headers: authHeader() });
    },
    getProduction() {
        const url = `${API_URL}/analytics/production`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getBasketTimes(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = `${API_URL}/analytics/basket-times${query ? `?${query}` : ''}`;
        return axios.get(url, { headers: authHeader() });
    },
    getProductionFinish() {
        const url = `${API_URL}/analytics/production?status=2`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getReportProductionUser(data) {
        return axios.post(`${API_URL}/export/production-user`, data, { 
            headers: {
                ...authHeader(), 
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob', 
        });
    }    
    
};